// ThemeProviderComponent.js

import React from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider } from '@material-ui/core/styles';
import { themeDark, themeLight } from './themes';

const ThemeProviderComponent = ({ children }) => {
  const darkMode = useSelector((state) => state.darkMode.darkMode);
  return (
    <ThemeProvider theme={darkMode ? themeDark : themeLight}>
      {children}
    </ThemeProvider>
  );
};

export default ThemeProviderComponent;
